import React from "react";
import { useParams } from "react-router-dom"
import { getApi } from '../../api/endpoints';
import ListingComponent from '../../components/ListingComponent';

const Listing = (props) => {
    const defaultHeaderConfig = { disableSort: false };
    
    const headers = [
      {
          ...defaultHeaderConfig,
          label: 'ID',
          attr: 'id',
      },
      {
          ...defaultHeaderConfig,
          label: 'Owner Name',
          attr: 'owner_name',
          disableSort: true
      },
      {
          label: 'Serial Number',
          attr: 'serial_no',
      },
      {
          ...defaultHeaderConfig,
          label: 'Model',
          attr: 'model',
          disableSort: true
      },
      {
          label: 'Chip Type',
          attr: 'chip_type',
          disableSort: true
      },
      {
          label: 'Status',
          attr: 'status',
          disableSort: true
      },
      {
          label: 'Invoice Number',
          attr: 'invoice_number',
          disableSort: true
      },
      {
          ...defaultHeaderConfig,
          label: 'Assigned At',
          attr: 'assigned_at',
      },
    ]

    return <>
      <ListingComponent
        key={'PAGES.RfidsListingPage.name'}
        listingMutation={getApi('rfids')}
        className="rfids-listing-page"
        contentHeading="Voltup Id Cards - Results"
        headers={headers}
        recordsKey="rfids"
        params={props.defaultParams}
        searchBy={['Serial Number', 'Invoice Number']}
      />
    </>
};

export default Listing;
